// src/components/ui/BottomSheet/index.tsx
import React, { useEffect, useState } from "react";
import { Overlay, Backdrop, Panel, CenteredPanel } from "./styles";

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxHeight?: string;
  /** Renderiza como modal centralizado (uso desktop). */
  centered?: boolean;
  width?: number;
}

export default function BottomSheet({
  open,
  onClose,
  children,
  maxHeight = "92%",
  centered = false,
  width = 460,
}: BottomSheetProps) {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const t = setTimeout(() => setShown(true), 20);
      return () => clearTimeout(t);
    }
    setShown(false);
    const t = setTimeout(() => setMounted(false), 280);
    return () => clearTimeout(t);
  }, [open]);

  if (!mounted) return null;

  return (
    <Overlay $centered={centered}>
      <Backdrop data-testid="sheet-backdrop" $shown={shown} onClick={onClose} />
      {centered ? (
        <CenteredPanel $shown={shown} $width={width}>{children}</CenteredPanel>
      ) : (
        <Panel $shown={shown} $maxHeight={maxHeight}>{children}</Panel>
      )}
    </Overlay>
  );
}
